import React, { createContext, useContext, useState } from 'react';

interface Participant {
  id: string;
  name: string;
}

interface WheelContextType {
  wheelItems: Participant[];
  setWheelItems: (items: Participant[]) => void;
}

const WheelContext = createContext<WheelContextType | undefined>(undefined);

export const WheelProvider = ({ children }: { children: React.ReactNode }) => {
  const [wheelItems, setWheelItems] = useState<Participant[]>([]);

  return (
    <WheelContext.Provider value={{ wheelItems, setWheelItems }}>
      {children}
    </WheelContext.Provider>
  );
};

export const useWheel = () => {
  const context = useContext(WheelContext);
  if (!context) {
    throw new Error('useWheel must be used within a WheelProvider');
  }
  return context;
}; 